<template>
  <div>
    <v-dialog
      @click:outside="onClose"
      @keydown.esc="onClose"
      v-model="dialog"
      scrollable
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          >Leads por asesor <v-spacer></v-spacer>
          <SortIcon
            :sort="sort"
            @toggleSort="sort = sort === 'asc' ? 'desc' : 'asc'"
          />
        </v-card-title>
        <div v-if="loading">
          <v-skeleton-loader
            v-for="(item, index) in 5"
            :key="index"
            type="list-item-avatar-two-line"
          />
        </div>
        <div v-else-if="items?.length === 0">
          <v-card-text>No hay datos para mostrar</v-card-text>
        </div>
        <v-card-text v-else>
          <div v-for="(item, index) in sortedItems" :key="item._id">
            <v-list subheader>
              <v-list-item @click="setActualLead(item._id)">
                <v-list-item-avatar>
                  <v-icon size="40">mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.contact_lead_name }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon class="mx-2" justify="space-between">
                  <v-chip :color="colorResponseTime(item.response_time_hours)">
                    {{ formatResponseTime(item.response_time_hours) }}
                  </v-chip>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
            <v-divider v-if="index < items.length - 1"></v-divider>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="onClose" text @click="onClose">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <lead-detail-modal
      ref="leadDetailModal"
      page="table"
      :dialog="showDetail"
      @setDialog="
        value => {
          showDetail = value;
        }
      "
    />
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import SortIcon from "../../../common/SortIcon.vue";
import colorResponseTime from "../../utils/colorResponseTime";
import formatResponseTime from "../../utils/formatResponteTime";
import LeadDetailModal from "../../../lead/LeadDetailModal.vue";

export default {
  name: "ModalDetailList",
  components: {
    SortIcon,
    LeadDetailModal
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: Boolean,
    dialog: Boolean,
    onClose: Function
  },
  data() {
    return {
      sort: "asc",
      showDetail: false
    };
  },
  computed: {
    ...mapState({
      lead: state => state.leads.actualItem
    }),
    sortedItems() {
      const items = this.items;
      return items.sort((a, b) => {
        if (this.sort === "asc") {
          return a.response_time_hours - b.response_time_hours;
        } else {
          return b.response_time_hours - a.response_time_hours;
        }
      });
    }
  },
  methods: {
    ...mapActions({
      fetchLead: "leads/fetchActualLead"
    }),
    ...mapMutations({
      setLoadingActualLead: "leads/setLoading"
    }),
    formatResponseTime,
    colorResponseTime,
    async setActualLead(leadId) {
      this.setLoadingActualLead(true);
      this.showDetail = true;

      await this.fetchLead(leadId);
      // Se hace este parseo para que cuando mute el lead, no cambie el secundario
      let data = JSON.parse(JSON.stringify(this.lead));
      this.$store.commit("leads/setSecondaryLead", data);
      this.setLoadingActualLead(false);
    }
  }
};
</script>
